/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM, T } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "@adapptio/lib-editor-ui";
import React from "react";
import { Badge, BADGE_POSITION } from "../../../../../ui/components/Badge";
import { TReferenceData } from "../../ReferenceGuideTypes";

export interface INavLinkProps {
	expand?: boolean;
	index?: number;
	handle: (e: any, item: TReferenceData, index?: number) => void;
	item: TReferenceData;
	label: string;
	descriptor?: any;
}

export const NavLink: React.FC<INavLinkProps> = ({ expand, index, handle, item, label, descriptor = {} }) => {
	const newTag = descriptor?.tags?.indexOf("new") >= 0 || false;
	const deprecatedTags = descriptor?.tags?.indexOf("deprecated") >= 0 || false;

	const baseClass = BEM("edt-reference-sidebar-navlink", null, {
		deprecated: deprecatedTags,
		new: newTag
	});

	return (
		<a href="/" className={baseClass.toClassName()} onClick={(e) => handle(e, item, index)}>
			{expand && (
				<Icon
					className={baseClass.element("arrow").toClassName()}
					name="mdi/menu-down"
					size={ICON_SIZE.MEDIUM}
				/>
			)}

			{newTag ? (
				<Badge position={BADGE_POSITION.END} content="new">
					<T domain="editor" term={label} />
				</Badge>
			) : (
				<span>
					<T domain="editor" term={label} />
				</span>
			)}
		</a>
	);
};
